// extracted by mini-css-extract-plugin
export default {"LoginPage":"LoginPage_LoginPage__yukH5","white":"LoginPage_white__oXbVa"};